import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../utils/axios.ts';

// Get SMS quota status
export function useSmsQuota() {
  return useQuery({
    queryKey: ['sms-quota'],
    queryFn: async () => {
      const response = await api.get('/sms/quota');
      return response.data;
    },
    enabled: true,
  });
}

// Get SMS pricing information
export function useSmsPricing() {
  return useQuery({
    queryKey: ['sms-pricing'],
    queryFn: async () => {
      const response = await api.get('/sms/pricing');
      return response.data;
    },
    enabled: true,
  });
}

// Get SMS recharge history
export function useSmsRechargeHistory(limit = 10) {
  return useQuery({
    queryKey: ['sms-recharge-history', limit],
    queryFn: async () => {
      const response = await api.get(`/sms/recharge/history?limit=${limit}`);
      return response.data;
    },
    enabled: true,
  });
}

// Calculate SMS cost
export function useCalculateSmsCost() {
  return useMutation({
    mutationFn: async (quantity) => {
      const response = await api.post('/sms/recharge/calculate-cost', { 
        sms_quantity: quantity 
      });
      return response.data;
    },
  });
}

// Initiate SMS recharge
export function useInitiateSmsRecharge() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (quantity) => {
      const response = await api.post('/sms/recharge', { 
        sms_quantity: quantity 
      });
      return response.data;
    },
    onSuccess: () => {
      // Invalidate and refetch quota and history
      queryClient.invalidateQueries({ queryKey: ['sms-quota'] });
      queryClient.invalidateQueries({ queryKey: ['sms-recharge-history'] });
    },
  });
} 